import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { redirecturl } from "../../services/common/redirect";
import { GetCacheKey, getGlobalSettingValue, getItemOfSessionStorage } from "../../services/common/utils";
import Loadingcomponent from "../loader/loadingcomponent";
import ErrorMessage from "../messaging/errormessage";
import {
    setAuthModalContent,
    setClicked2FAData,
    setShowAuthModal,
    setShowEnableMediumAuthBtn,
    setShowGetKuwaitAppBtn,
  } from "../../reducer/utilitySlice";
import {useSelector, useDispatch} from 'react-redux';
import { IS_2FA_DONE } from '../../services/common/Constants';
import { setClickedTrasferPointsCardData } from '../../reducer/nojoomSlice';
import ExclusiveModal from "../../components/common/exclusive-modal";
const QuicklinksComponent = ({ pmsitem }) => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const [deeplinktext,setdeeplinktext] = useState('');
    const {
        utilityData: { globalSetting },
    } = useSelector((state) => state);
    const dispatch = useDispatch();
    const toggleModal = () => {
        setShow(!show)
    }
    const {
        data: { data } = {},
        isLoading,
        error,
        isFetching,
        isError,
        isLoadingError
    } = useQuery(["", pmsitem.method, JSON.parse(pmsitem.sourceid), {}, false], {
        retry: false,
        retryOnMount: false,
        cacheTime: 30000,
        staleTime: 30000,
    });

    const [links, setlinks] = useState(null);

    useEffect(() => {
        try {


            if (data != null && data.response != null && data.response?.dynamictypes != null && data.response?.dynamictypes.length > 0) {
                if (data.response?.dynamictypes[0].cards != null && data.response?.dynamictypes[0].cards.length > 0) {
                    setlinks(data.response?.dynamictypes[0].cards);
                }
            }
        } catch (e) { }
    }, [data])

    if (isLoading || isFetching) {
        return (
            // <Loadingcomponent message={"Loading"} />
            <div class="white_card quicklink_card dls13_quicklink_card">
                            <h3 class="primary_16 text-center mb-4 shimmerBG shimmer-text-lg w-50 m-auto"></h3>
                            <ul class="quicklink_list" style={{justifyContent:"flex-start"}}>
                                <li class="quicklink_item w-20">
                                    <div class="shimmerBG shimmer-icon-md">
                                    </div>
                                    <p class="mb-0 shimmerBG shimmer-text-md p-2 w-100"></p>
                                </li>
                                <li class="quicklink_item">
                                    <div class="shimmerBG shimmer-icon-md">
                                       
                                    </div>
                                    <p class="mb-0 shimmerBG shimmer-text-md p-2 w-100"></p>
                                </li>
                                <li class="quicklink_item">
                                    <div class="shimmerBG shimmer-icon-md">
                                    </div>
                                    <p class="mb-0 shimmerBG shimmer-text-md p-2 w-100"></p>
                                </li>
                                <li class="quicklink_item">
                                    <div class="shimmerBG shimmer-icon-md">
                                    </div>
                                    <p class="mb-0 shimmerBG shimmer-text-md p-2 w-100"></p>
                                </li>
                                <li class="quicklink_item">
                                    <div class="shimmerBG shimmer-icon-md">
                                    </div>
                                    <p class="mb-0 shimmerBG shimmer-text-md p-2 w-100"></p>
                                </li>
                                <li class="quicklink_item">
                                    <div class="shimmerBG shimmer-icon-md">
                                    </div>
                                    <p class="mb-0 shimmerBG shimmer-text-md p-2 w-100"></p>
                                </li>
                            </ul>
                        </div>
        );
    }

    if (error || isError || isLoadingError || links == null || links?.length == 0) {
        return <section class="">

        </section>
    }

    const navigateitem = (x,objData) => {

        try{
            if(objData?.metadata != null && objData?.metadata != undefined && objData?.metadata != ""
            && objData?.metadata?.length > 0){
                for (var i = 0; i < objData?.metadata?.length; i++) {
                    if (objData?.metadata[i]?.meta_key == "web_deeplink") {
                      let deeplink = objData?.metadata[i]?.meta_value_english;
                      setShow(true);
                      setdeeplinktext(deeplink);
                      return false;
                    }
                    if (objData?.metadata[i]?.meta_key == "web_notallowed") {
                      //need to show popup for only app feature
                      // console.log("exclusive feature for app");
                      setShow(true);
                      return false;
                    }
                    else if (objData?.metadata[i]?.meta_key == "web_redirection") {
                      let _url = objData?.metadata[i]?.meta_value_english;
                      if (_url.indexOf("http") >= 0) {
                        window.open(_url, '_blank');
                        return false;
                      }
                      else {
                        navigate("/" + _url);
                        return false;
                      }
                    }
                    else{
                        try {
                            setdeeplinktext(objData?.redirecturl)
                            redirecturl(x, navigate, show, toggleModal)
                        } catch (error) {
            
                        }
                    }
                  }
          }
          }catch{}

        if(x === '/paytransfercredits' && getItemOfSessionStorage(IS_2FA_DONE) !== 'true'){
            const requiredRedirectData = {
                url: '/paytransfercredits',
                state: null,
              };
            const settingsArr = globalSetting
                ? globalSetting?.Globalsettings[0]?.items[0]?.metadata : [];
            dispatch(
                setAuthModalContent({
                icon: getGlobalSettingValue("beforeverificationicon", settingsArr),
                title: getGlobalSettingValue("beforeverificationtitle", settingsArr),
                message: getGlobalSettingValue("beforeverificationmsg", settingsArr),
                btnText: getGlobalSettingValue(
                    "beforeverificationbuttontext",
                    settingsArr
                ),
                })
            );
            dispatch(setShowAuthModal(true));
            dispatch(setClicked2FAData(requiredRedirectData));
        }
        else{
            try {
                // console.log("-------------dafs")
                // console.log(x, "xxxx")
                setdeeplinktext(objData?.redirecturl)
                redirecturl(x, navigate, show, toggleModal)
            } catch (error) {

            }
        }
    }

    return <div>
        <div className="white_card quicklink_card">
            <h3 className="primary_16 text-center mb-4">{data.response?.dynamictypes[0]?.heading}</h3>
            <ul className="quicklink_list" style={{justifyContent:links?.length <=3 ? 'center' : 'start'}}>
                {
                    links.map(x => {
                        // console.log(x?.redirecturl, "xxx")
                        return (
                            <li onClick={() => {
                                if (
                                    x?.redirecturl.startsWith('http') ||
                                    x?.redirecturl.startsWith('https')
                                ) {
                                    window.open(
                                        x?.redirecturl,
                                        '_blank' // <- This is what makes it open in a new window.
                                    );
                                }
                                else {
                                    navigateitem(`/${x?.redirecturl}`,x)

                                }
                            }
                            } className="quicklink_item">
                                <div className="quicklink_item_img">
                                    <img src={x.imageurl} alt="" title="" style={{width: "56px", height: "56px"}} />
                                </div>
                                <p className="mb-0">{x.displaytext}</p>
                            </li>
                        )

                    })
                }

            </ul>
        </div>
        <ExclusiveModal show={show} toggleModal={toggleModal} 
        deeplinktext={deeplinktext}/>
    </div>
}
export default QuicklinksComponent;